import React from 'react';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout'
import { keycloakLogout } from '../auth/logout';

const FloatinglogoutButton = () => {
  const handleClick = async () => {
    // Logout from Keycloak and redirect to home
    await keycloakLogout(window.location.origin);
  };

  return (
    <Tooltip 
      title={<Typography sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
        Logout
      </Typography>}
    >
      <Fab
        color="primary"
        aria-label="logout"
        size="small" 
        onClick={handleClick}
        sx={{
          position: 'fixed',
          top: 75,
          left: 'calc(100% - 60px)', 
          zIndex: 1000,
          backgroundColor: '#2a366e',  
          '&:hover': {
            backgroundColor: '#4519e6ff',  
          },
        }}
      >
        <LogoutIcon sx={{ fontSize: 25 }} />
      </Fab>
    </Tooltip>
  );
};

export default FloatinglogoutButton;
